<template>
  <label class="relative w-full">
    <input
      v-if="!showPassword"
      v-model="value"
      :placeholder="placeholder"
      :class="{
        'border border-gray-300 dark:border-input-border-dark': border,
      }"
      type="password"
      autocomplete="new-password"
      class="w-full rounded-xl bg-transparent p-3 pr-10 placeholder:text-sm focus-within:ring-primary-button focus-visible:outline-none focus-visible:ring-2"
    />
    <input
      v-if="showPassword"
      v-model="value"
      :placeholder="placeholder"
      :class="{
        'border border-gray-300 dark:border-input-border-dark': border,
      }"
      type="text"
      autocomplete="new-password"
      class="w-full rounded-xl bg-transparent p-3 pr-10 placeholder:text-sm focus-within:ring-primary-button focus-visible:outline-none focus-visible:ring-2"
    />
    <button
      tabindex="-1"
      class="absolute inset-y-0 right-0 flex items-center pr-3"
      @click.prevent="showPassword = !showPassword"
      @keydown.enter.prevent="false"
    >
      <nuxt-icon v-show="!showPassword" name="eye-open" title="Show password" class="text-2xl descendant:text-primary-button" />
      <nuxt-icon v-show="showPassword" name="eye-closed" title="Hide password" class="text-2xl descendant:text-primary-button" />
    </button>
  </label>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: string;
  border?: boolean;
  placeholder?: string;
}>();
const emit = defineEmits<{
  (e: "update:modelValue", value: string | number): void;
}>();

const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const showPassword = ref(false);
</script>
